// src/context/MyContext.jsx
import React, { createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
// 1️⃣ Create Context
export const MyContext = createContext();

// 2️⃣ Create Provider
export const MyProvider = ({ children }) => {
  // Directly read from sessionStorage during initial render
  const storedUser = sessionStorage.getItem("student");
  const parsedUser = storedUser ? JSON.parse(storedUser) : null;
  const [storedCourse, storeCourseData] = useState({});

  const [user, setUser] = useState(parsedUser);
  const [isLogin, setLogin] = useState(!!parsedUser);
  const [activeGC, setActiveGC] = useState("");
  const [value, setValue] = useState("");
  const [showSubmissionForm, setShowSubmissionForm] = useState(false);
  const [isOpenEnrollForm, setToggleEnrollForm] = useState(false);

  //for project submission form
  const [activeProjectId, submitProjectId] = useState("");

  const [selectedCourse, setSelectedCourse] = useState(null);

  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth > 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [showHelpDesk, setShowHelpDesk] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isAdminTabActive, setToggleAdminTab] = useState(false);

  // Whenever user updates → sync it to sessionStorage
  const updateUser = (newUser) => {
    setUser(newUser);
    if (newUser) {
      localStorage.setItem("student", JSON.stringify(newUser));
      setLogin(true);
    } else {
      localStorage.removeItem("student");
      setLogin(false);
    }
  };
  useEffect(() => {
    const token = Cookies.get("token");

    if (!token && isLogin !== false) {
      setLogin(false);
    }
  }, []);

  return (
    <MyContext.Provider
      value={{
        value,
        setValue,
        user,
        setUser: updateUser,
        isLogin,
        setLogin,
        activeGC,
        setActiveGC,
        showSubmissionForm,
        setShowSubmissionForm,
        isSidebarOpen,
        setIsSidebarOpen,
        showHelpDesk,
        setShowHelpDesk,
        isSubmitting,
        setIsSubmitting,
        storedCourse,
        storeCourseData,
        isAdminTabActive,
        setToggleAdminTab,
        isOpenEnrollForm,
        setToggleEnrollForm,
        activeProjectId,
        submitProjectId,
        selectedCourse,
        setSelectedCourse,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};
